import React from 'react';
import {FormattedMessage} from 'react-intl';
import {
    ERROR_NAME,
    ERROR_EMAIL,
    ERROR_PHONE,
    ERROR_RESERVATION_NUMBER,
    ERROR_CERTIFICATE_NUMBER,
    ERROR_ORDERID,
    ERROR_UPLOAD_IMAGE
} from './constants';
import {times} from 'lodash';
// eslint-disable-next-line no-control-regex
export const emailRegexPattern = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
// email regex from https://github.com/thedersen/backbone.validation/blob/master/src/backbone-validation.js#L453

export const nameRegexPattern = /^([a-zA-Z ]){2,50}$/;
// max of 50 character, min of 2 character , only a-z, A-Z allowed

export const certificateRegexPattern = /^[a-zA-Z0-9]{1,32}$/;
// only alphanumeric allowed max of 32 min of 1

export const orderIdRegexPattern = /^[0-9]{1,32}$/;
// only numbers allowed max of 32 min of 1

export const reservationNumberRegexPattern = /^.{1,50}$/;
// Any value with  max of 50 and min of 1

export const getFormattedMessage = (linguaKey, defaultMessage) => {
    return (
        <FormattedMessage id={linguaKey} defaultMessage={defaultMessage} />
    );
};
export const validateEmail = (email) => {
    const isValidEmail =
        email && email.indexOf('..') === -1 && emailRegexPattern.test(email);
    if (!isValidEmail) {
        return getFormattedMessage('giftCardFormEmailErrorMessage', ERROR_EMAIL);
    }
    return null;
};

export const validateName = (name) => {
    const isValidname = name && nameRegexPattern.test(name);
    if (!isValidname) {
        return getFormattedMessage('giftCardFormNameErrorMessage', ERROR_NAME);
    }
    return null;
};

export const validatePhone = (number) => {
    let errorMsg = null;
    if (!number) {
        errorMsg = ERROR_PHONE;
    }
    return errorMsg;
};

export const validateImage = (photoUrl, errorMessage = ERROR_UPLOAD_IMAGE) => {
    if (!photoUrl) {
        return getFormattedMessage('giftCardFormOrderIdErrorMessage', errorMessage);
    }
    return null;
};

export const validateOrderId = (orderId) => {
    const isValidOrderId = orderId && orderIdRegexPattern.test(orderId);
    if (!isValidOrderId) {
        return getFormattedMessage('giftCardFormOrderIdErrorMessage', ERROR_ORDERID);
    }
    return null;
};

export const validateCertificateNumber = (certificateNumber) => {
    const isValidCertificateNumber =
        certificateNumber && certificateRegexPattern.test(certificateNumber);
    if (!isValidCertificateNumber) {
        return getFormattedMessage('giftCardFormCertificateNumberErrorMessage', ERROR_CERTIFICATE_NUMBER);
    }
    return null;
};

export const validateReservationNumber = (reservationNumber) => {
    const isValidReservationNumber =
         reservationNumber && reservationNumberRegexPattern.test(reservationNumber);
    if (!isValidReservationNumber) {
        return getFormattedMessage('giftCardFormReservationNumberErrorMessage', ERROR_RESERVATION_NUMBER);
    }
    return null;
};

export const getReduxFormError = ({values, giftCardCount}) => {
    let errorObj = {};
    const errorFirstName = validateName(values.firstName);
    const errorLastName = validateName(values.lastName);
    const errorEmail = validateEmail(values.email);
    const errorPhone = validatePhone(values.phone && values.phone.phoneNumber);
    const errorReservationNumber = validateReservationNumber(values.reservationNumber);
    times(giftCardCount, (index) => {
        const errorOrderId = validateOrderId(values[`orderId${index}`]);
        const errorCertificateNumber = validateCertificateNumber(values[`certificateNumber${index}`]);
        const errorPhotoUrl = validateImage(values[`giftCardImageUploader${index}`]);

        Object.assign(
            errorObj,
            errorOrderId && {[`orderId${index}`]: errorOrderId},
            errorCertificateNumber && {
                [`certificateNumber${index}`]: errorCertificateNumber
            },
            errorPhotoUrl && {[`giftCardImageUploader${index}`]: errorPhotoUrl}
        );
    });

    Object.assign(
        errorObj,
        errorFirstName && {firstName: errorFirstName},
        errorLastName && {lastName: errorLastName},
        errorEmail && {email: errorEmail},
        errorPhone && {phone: errorPhone},
        errorReservationNumber && {reservationNumber: errorReservationNumber}
    );
    return errorObj;
};
